import React from 'react';
import {
    BrowserRouter, useNavigate
} from "react-router-dom";
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { Provider } from 'react-redux'
import { createStore } from 'redux';
import reducer from '../src/store/reducer/index'
import { SnackbarProvider } from 'notistack';
const store = createStore(
    reducer,
);

window.OBPubConfig = {
    activeMenu: '',
    loading: false,
    preLoader: false,
    // menu: {
    //     active: ''
    // },
};
localStorage.setItem('sas_school_language', 'vi');

if ("serviceWorker" in navigator) {
    navigator.serviceWorker
        .register("./firebase-messaging-sw.js")
        .then(function(registration) {
            // console.log("Registration successful, scope is:", registration.scope);
        })
        .catch(function(err) {
            // console.log("Service worker registration failed, error:", err);
        });
}
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store = {store}>
        <SnackbarProvider
            autoHideDuration={2000}
            maxSnack={10}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </SnackbarProvider>
    </Provider>
);
reportWebVitals();
